<div class="modal">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="loading-screen" *ngIf="isLoading">
        <div class="loading">
            <div id="loader"></div>
            <div class="loading-content">
              <p>
                Deleting Request...
              </p>
            </div>
        </div>
      </div>
      <div class="modal-header">
        <h4 class="pagetitle">Delete Request</h4>
        <span
          class="table-material-icons close-button"
          (click)="activeModal.dismiss('Cross click')"
          (keydown)="activeModal.dismiss('Cross click')"
        >
          close
        </span>
      </div>
      <div class="modal-body">
        <div *ngIf="errorMessage" class="error-message">
          {{ errorMessage }}
        </div>
        <p>
          Are you sure you want to delete this request? This action cannot be undone.
        </p>
        
          <div class="modal-footer">
            <app-button
              size="medium"
              buttonType="primary"
              type="submit"
              class="select-button"
              (click)="cancelRequest(this.prfyear, this.groupcode, this.ticketid, 'Remove', this.prfuser)"
              (keydown)="cancelRequest(this.prfyear, this.groupcode, this.ticketid, 'Remove', this.prfuser)"
            >
               Confirm
            </app-button>
            <app-button
              size="medium"
              (click)="activeModal.dismiss('Cross click')"
              (keydown)="activeModal.dismiss('Cross click')"
              buttonType="secondary"
            >
              Close
            </app-button>
          </div>

      </div>
    </div>
  </div>
</div>